function StatPill({ label, value }) {
    return (
      <div className="rounded-2xl bg-slate-50 px-4 py-4 ring-1 ring-slate-200">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
          {label}
        </p>
        <p className="mt-2 text-xl font-bold tracking-tight text-slate-900">
          {value}
        </p>
      </div>
    );
  }
  
  export default StatPill;